import i18n from '@/i18n'
import { getDiscountedPrice } from '@/helpers/productListHelpers/productListGetters'
import { OFFER_TYPE } from '@/helpers/constants'

export const getDiscountsEditionProductTableList = productList =>
  getProductTableList(productList, getDiscountsEditionProductTable)

export const getPdfProductTableList = (productList, offerType) =>
  getProductTableList(productList, getPdfProductTable, offerType)

export const getProductListUnitPrices = productList =>
  getProductTableList(productList, getProductUnitPrices)

const getProductTableList = (productList, getProductTableFn, offerType) => {
    const productTableList = {}
  for (const product of productList) {
    productTableList[product.id] = getProductTableFn(product, offerType)
  }
  return productTableList
}

const getPdfProductTable = (product, offerType) => {
  // Use desc_key for display headers, or construct ZONE_ key if not available
  const headers = product.zoneList.map(zone => zone.desc_key || `ZONE_${zone.id}`)
  const addKilo = product.additionalKilo
    ? product.zoneList.map(zone =>
        offerType === OFFER_TYPE.C || zone.additionalKgValue
          ? Number(zone.additionalKgValue).toFixed(2)
          : getDiscountedPrice(zone.defaultAdditionalKgValue, zone.amountOutOfDiscount),
      )
    : []
  const kgRows = getKgRowsForPdfTable(product)
  return {
    headers,
    addKilo,
    kgRows,
  }
}

const getKgRowsForPdfTable = product => {
  const kgRows = {}
  const weightList = product.zoneList[0].basePrices.map(item => item.id)
  for (const weight of weightList) {
    const row = []
    for (let iZone = 0; iZone < product.zoneList.length; iZone++) {
      const priceItem = product.zoneList[iZone].basePrices.find(item => item.id === weight)
      row.push(priceItem?.price ? priceItem.price : '')
    }
    kgRows[weight] = row
  }
  return kgRows
}

const getDiscountsEditionProductTable = product => {
  //formatted for being used in Vuetify table
  // IMPORTANT: Use zone.id as header keys so validation (which uses zone IDs) can work properly
  const headers = product.zoneList.map(zone => zone.id)
  const addKilo = product.additionalKilo ? getAddKgRowForShippingTable(product) : null
  const kgRows = getKgRowsForShippingTable(product)
  const discounts = getDiscountsForShippingTable(product)
  return {
    headers,
    addKilo,
    kgRows,
    discounts,
  }
}

const roundNumber = value => Math.round(value * 100) / 100

const getDiscountsForShippingTable = product => {
  const row = { weight: '' }
  for (const zone of product.zoneList) {
    row[zone.id] = zone.amountOutOfDiscount
  }
  return row
}

const getAddKgRowForShippingTable = product => {
  const row = { weight: i18n.t('SHIPPING_ADDITIONAL_KG') }
  for (const zone of product.zoneList) {
    row[zone.id] = roundNumber(zone.additionalKgValue)
  }
  return row
}

const getKgRowsForShippingTable = product => {
  const kgRows = []
  for (const weight of product.currentWeightIdList) {
    const row = { weight }
    for (const zone of product.zoneList) {
      const priceIndex = zone.basePrices.findIndex(el => el.id === weight)
      if (priceIndex === -1)
        continue
      row[zone.id] = roundNumber(zone.basePrices[priceIndex].price)
    }
    kgRows.push(row)
  }
  return kgRows
}

const getProductUnitPrices = product => {
  const fixedPrice = product.fixedPrice || 0
  const productUnitPrices = {}
  for (const zone of product.zoneList) {
    productUnitPrices[zone.id] = getProductZonePriceForKiloUnit(zone, fixedPrice)
  }
  return productUnitPrices
}

const getProductZonePriceForKiloUnit = (zone, fixedPrice) => {
  const kiloUnitDefPrice = zone?.defaultPrices.find(item => item.id === 1).price
  const discountedPrice = getDiscountedPrice(kiloUnitDefPrice, zone.amountOutOfDiscount, fixedPrice)
  return discountedPrice
}
